import pageToDocumentCoordinates from './pageToDocumentCoordinates';
import { getCanvasBounds } from '../viewstate';

export default function getCanvasDocumentBounds() {
    const { top, left, bottom, right } = getCanvasBounds();
    const docTopLeft = pageToDocumentCoordinates(left, top);
    const docBottomRight = pageToDocumentCoordinates(right, bottom);
    return {
        canvasTop: docTopLeft.y,
        canvasLeft: docTopLeft.x,
        canvasBottom: docBottomRight.y,
        canvasRight: docBottomRight.x,
        canvasHeight: docBottomRight.y - docTopLeft.y,
        canvasWidth: docBottomRight.x - docTopLeft.x,
        canvasElementHeight: bottom - top,
        canvasElementWidth: right - left,
    };
}
